module.exports = __webpack_public_path__ + "static/media/hicks_tripolino_bennett.b8411b64.jpg";